<template>
    <div v-if="isShow" :style="domStyle">
        <div v-if="isEnable" :style="enableStyle"></div>
        <img v-if="isLog" src="" style="width: 100%;height:100%">
    </div>
</template>
<style>
    .jsgif canvas{
        width:0;
        height:0;
    }
</style>
<script>
/**
 * gif，支持动态图片  不支持层级
 */
import Vue from 'vue';
import SuperGif from "libgif";
export default {
    name : "fvGifGraph",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        this.defaultTailoring = this.parentObject.defaultTailoring;
        this.windowSize = this.parentObject.windowSize;
        //组件数据混淆
        this.mixin(this.primitives);
        this.windowsObject = this.$parent.$parent;
        this.workbench = this.windowsObject.workbench;
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : 0 + "px",
            top : 0 + "px",
            width : 0 + "px",
            height : 0 + "px",
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.monitor();
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        this.originalSize={
            x:this.x,
            y:this.y
        }
    },
    mounted(){
        var img = document.createElement("img");
		this.$el.appendChild(img);
        img.src = this.fileData;
        img.onload = function(){
            img.style.width = "1px";
            img.style.height = "1px";
            this.rub = new  SuperGif({ 
                gif: img,
                progressbar_height:"2px"
            } );
            this.rub.load(()=>{
                this.$el.childNodes[3].childNodes[0].style.width = parseInt(this.$el.style.width)-2+"px";
                this.$el.childNodes[3].childNodes[0].style.height = parseInt(this.$el.style.height)-2+"px";
                this.rub.pause();
                this.rub.move_relative(1);
                this.setPlay();
            });
            
        }.bind(this)
        if(this.isGifbor){
            this.$el.style.border = "1px solid";
            this.$el.style.borderColor = this.Gifbcolor;
        }else{
            this.$el.style.border = "0px solid";
        }
    },
    data(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            second:0,//记录循环多少次了
            isLog:false,
            // 版本号
            version: "10.0.3.1"
        }
    },
    methods : {
        //暂停setPause
        setPause(){
            // this.rub.pause();
            clearTimeout(this.timing)
            this.timing = undefined;
        },
        //播放
        setPlay(){
            if(this.timing == undefined && this.isEnable == false){
                this.timing = setInterval(function(){ 
                    //判断是否启用循环次数
                    if(this.frequency != -1){
                        if(this.second > parseInt(this.frequency)){
                            this.setPause();
                        }
                        if(this.rub.get_current_frame() == this.rub.get_length()-1){
                            this.second +=1;
                        }
                    }
                    this.rub.move_relative(1);
                }.bind(this),this.speed);
            }
        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.disableFlag){
                return;
            }
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.domStyle.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            };
            if(scaleObj.titleHeight != 0){
                var titleHeight = 0;
            }else{
                var titleHeight = this.y * this.frameScaleY;
            }
            this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.domStyle.top = parseInt(((this.y )* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
            
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
            if(this.isEnable){
                this.setPause();
            }
        },
        /*
            参数：src ：外部属性（对象）
            作用：混淆属性
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：无
            作用：监听组件内部属性
        */
        monitor(){
            //监听是否为图片增加边框
            Object.defineProperty(this,"Border",{
                set(value){
                    if(value == 0){
                        this.picStyle.border = "none";
                    }else{
                        this.picStyle.border = `${this.borderWidth}px solid ${this.borderColor}`;
                    }
                    this.$forceUpdate();
                },
                get(){
                    return this.picStyle.border
                }
            });
            //监听图片边框宽度
            Object.defineProperty(this,"LineWidth",{
                set(value){
                    if(this.picStyle.border == "none"){
                        this.borderWidth = value;
                    }else{
                        this.borderWidth = value;
                        this.picStyle.border = `${value}px solid ${this.borderColor}`
                        this.$forceUpdate();
                    }
                },
                get(){
                    return this.picStyle.border
                }
            })
            //监听图片精灵文件读取路径
            Object.defineProperty(this,"Path",{
                set(value){
                    this.home_url = `src/New App1/img/${value}`;
                    this.$forceUpdate();
                },
                get(){
                    return this.home_url;
                }
            })
            //监听旋转角度
            Object.defineProperty(this,"Rotate",{
                set(value){
                    this.picStyle.transform = `rotate(${value}deg)`;
                    if(this.isEnable){
                         this.enableStyle.transform=`rotate(${value}deg)`;
                    }
                    this.$forceUpdate();
                },
                get(){
                    return this.picStyle.transform;
                }
            })
            //监听透明度
            Object.defineProperty(this,"Transparency",{
                set(value){
                    var num = Number(value / 255)
                    this.picStyle.opacity = num;
                    this.$forceUpdate();
                },
                get(){
                    return this.picStyle.opacity;
                }
            })
            //监听背景色
            Object.defineProperty(this,"TransparencyBackColor",{
                set(value){
                    this.picStyle.backgroundColor = value;
                    this.$forceUpdate();
                },
                get(){
                    return this.picStyle.backgroundColor;
                }
            })
        },

        imgLoadError(){
            this.$nextTick(() => {
                this.home_url = require('../../../assets/errPic.jpg');
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/primitives/fvGif/fvGifGraph.vue